import React, { useState } from 'react';
import {
  styled,
  useTheme,
  Drawer,
  Divider,
  List,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { Link } from 'react-router-dom';
import EmailIcon from '@mui/icons-material/Email';
import HomeIcon from '@mui/icons-material/Home';
import ArticleIcon from '@mui/icons-material/Article';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useTranslation } from 'react-i18next';

const BASE_PATH = '/peoplefortech/v2';

const drawerWidth = 240;

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 5),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-start',
}));

const DrawerItemV2 = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const itemList = [
    { text: t("nav.home"), icon: <HomeIcon />, to: BASE_PATH },
    { text: t("v2.booking.cta"), icon: <EventAvailableIcon />, to: `${BASE_PATH}/reserva` },
    { text: t("nav.blog"), icon: <ArticleIcon />, to: "/blog" },
    { text: t("nav.contact"), icon: <EmailIcon />, to: `${BASE_PATH}/contact` },
  ];

  return (
    <>
      <IconButton
        aria-label="open drawer"
        edge="end"
        onClick={() => setOpen(true)}
        sx={{
          color: 'black',
          '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
        }}
      >
        <MenuIcon />
      </IconButton>
      <Drawer
        sx={{ '& .MuiDrawer-paper': { width: drawerWidth } }}
        variant="temporary"
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
      >
        <DrawerHeader>
          <IconButton onClick={() => setOpen(false)}>
            {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {itemList.map((item) => (
            <ListItem
              key={item.to}
              component={Link}
              to={item.to}
              onClick={() => setOpen(false)}
              sx={{
                color: '#414141',
                "&:hover": { backgroundColor: '#e9e5e5', color: '#1c2859' },
              }}
            >
              <ListItemIcon sx={{ "&:hover": { backgroundColor: 'transparent', color: '#1c2859' } }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  );
};

export default DrawerItemV2;
